<template>
    <p class="m-0">{{ formatDate }}</p>
</template>

<script>
import DateFormatEnum from '~/enums/DateFormatEnum.js';
import moment from 'moment';

export default {
  name: "DateCell.vue",
  props: {
    cellProps: {
      type: String
    },
  },
  computed:{
    formatDate(){
      return this.cellProps ? moment(this.cellProps).format(DateFormatEnum.DISPLAY_DATE) : 'Onbekend';
    }
  }
}
</script>
